let sustainableAnswers;
let sustainableAnswersCarousel;
let sustainableAnswersHeight;

function updateSustainableAnswersHeight() {
  // Remove Set Carousel Height
  document.querySelector('#shopify-section-sustainability-features .sustainable-features').style.height = '';
    
  sustainableAnswers = document.querySelector('#shopify-section-sustainability-features .sustainable-features');
  if ( window.innerWidth < 700 ) {
    sustainableAnswers.querySelectorAll('.sustainable-feature').forEach(function(item) {
      if (item.clientHeight > sustainableAnswersHeight) {
        sustainableAnswersHeight = item.clientHeight = sustainableAnswersHeight
      }
    });
  } else {
    sustainableAnswersHeight = document.querySelector('#shopify-section-sustainability-features .sustainable-feature:nth-child(2)').clientHeight;
  }
  // Update Carousel
  document.querySelector('#shopify-section-sustainability-features .sustainable-features').style.height = `${sustainableAnswersHeight}px`;  
}

window.addEventListener('DOMContentLoaded',function () {  
  updateSustainableAnswersHeight();
  sustainableAnswersCarousel = new Flickity( sustainableAnswers, {
      cellSelector: '.sustainable-feature.cell',
	  wrapAround: false,
      imagesLoaded: true,
      pageDots: false,
      groupCells: false,
      prevNextButtons: true,
      autoplay: false,
      cellAlign: 'left',
      watchCSS: true,
      arrowShape: { 
          x0: 10,
          x1: 60, y1: 50,
          x2: 65, y2: 45,
          x3: 20
      }
  });
});

window.addEventListener('DOMContentLoaded',function () {
  sustainableAnswersCarousel.resize();
  updateSustainableAnswersHeight();
});